(() => {
  const ATTRIBUTE_NAME = 'Long Sleeve Order Details';
  let syncing = false;

  async function syncLongSleeveDetails() {
    if (syncing) return;
    syncing = true;

    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Unable to read cart');

      const cart = await response.json();

const products = new Map();

cart.items
  .filter(item =>
    item.properties?.[ATTRIBUTE_NAME] &&
    item.product_id
  )
  .forEach(item => {
    const productId = String(item.product_id);
    const productTitle = item.product_title;
    const configurationQuantity = item.quantity;
    const description = item.properties[ATTRIBUTE_NAME];

    if (!products.has(productId)) {
      products.set(productId, {
        title: productTitle,
        styles: new Map()
      });
    }

    const product = products.get(productId);

    description.split(' | ').forEach(entry => {
      const separator = ' — ';
      const separatorIndex = entry.indexOf(separator);

      if (separatorIndex === -1) return;

      const style = entry.slice(0, separatorIndex).trim();
      const sizeDetails = entry.slice(separatorIndex + separator.length).trim();

      const match = sizeDetails.match(/^(.*?)\s*[×x]\s*(\d+)$/);

      if (!match) return;

      const colorAndSize = match[1].trim();
const quantity = Number(match[2]) * configurationQuantity;

// Keep each color and size combination separate.
const size = colorAndSize;

if (!product.styles.has(style)) {
  product.styles.set(style, new Map());
}

const sizes = product.styles.get(style);
sizes.set(size, (sizes.get(size) || 0) + quantity);
    });
  });

const details = Array.from(products.entries())
  .flatMap(([productId, product]) => {
    const entries = [];

    product.styles.forEach((sizes, style) => {
  const sizeOrder = [
    'XSmall',
    'Small',
    'Medium',
    'Large',
    'XLarge',
    '2XLarge',
    '3XLarge',
    '4XLarge',
    '5XLarge'
  ];

  const colorOrder = ['Black', 'Charcoal', 'Navy'];

const sortedSizes = Array.from(sizes.entries()).sort(
  ([a], [b]) => {
    const [colorA, sizeA] = a.split(' / ');
    const [colorB, sizeB] = b.split(' / ');

    const colorIndexA = colorOrder.indexOf(colorA);
    const colorIndexB = colorOrder.indexOf(colorB);

    if (colorIndexA !== colorIndexB) {
      return (colorIndexA === -1 ? 999 : colorIndexA) -
             (colorIndexB === -1 ? 999 : colorIndexB);
    }

    const sizeIndexA = sizeOrder.indexOf(sizeA);
    const sizeIndexB = sizeOrder.indexOf(sizeB);

    return (sizeIndexA === -1 ? 999 : sizeIndexA) -
           (sizeIndexB === -1 ? 999 : sizeIndexB);
  }
);

  sortedSizes.forEach(([size, quantity]) => {
        const description = `${style} — ${size} × ${quantity}`;

        if (entries.length === 0) {
          entries.push(
            `[Product: ${product.title} | ID: ${productId}] ${description}`
          );
        } else {
          entries.push(description);
        }
      });
    });

    return entries;
  })
  .join(' | ');

      // Avoid unnecessary updates.
      if ((cart.attributes?.[ATTRIBUTE_NAME] || '') === details) {
        return;
      }

      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            [ATTRIBUTE_NAME]: details
          }
        })
      });

      if (!updateResponse.ok) {
        throw new Error('Unable to update cart attributes');
      }

      console.log('Ghost Lab long sleeve details synchronized:', details);
    } catch (error) {
      console.error('Ghost Lab long sleeve synchronization failed:', error);
    } finally {
      syncing = false;
    }
  }

  // Synchronize existing cart contents when the page loads.
  document.addEventListener('DOMContentLoaded', syncLongSleeveDetails);

  // Synchronize after Shopify publishes a cart update.
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncLongSleeveDetails);
  }

  // Also synchronize when returning to the cart page.
  window.addEventListener('pageshow', syncLongSleeveDetails);
})();